export const HELP_ROOT = '/help/pages/';
export const HELP_ADMIN_PATH = `${HELP_ROOT}admin/`;
export const EMBED_PARAM = '?embeddable';
export const EXPORT_LOCATIONS_HELP = `${HELP_ADMIN_PATH}export_locations${EMBED_PARAM}`;
export const GROUPS_HELP = `${HELP_ADMIN_PATH}user_groups${EMBED_PARAM}`;
export const TEAMS_HELP = `${HELP_ADMIN_PATH}teams${EMBED_PARAM}`;
export const TEAM_ADMINISTRATION_HELP = `${HELP_ADMIN_PATH}team_administration${EMBED_PARAM}`;
export const ROLE_GROUPS_HELP = `${HELP_ADMIN_PATH}role_groups${EMBED_PARAM}`;
export const ROLES_HELP = `${HELP_ADMIN_PATH}roles${EMBED_PARAM}`;
export const JOBS_HELP = `${HELP_ADMIN_PATH}jobs/${EMBED_PARAM}`;
export const METADATA_CATEGORIES_HELP = `${HELP_ADMIN_PATH}metadata_categories/${EMBED_PARAM}`;
export const METADATA_FIELDS_HELP = `${HELP_ADMIN_PATH}metadata_fields/${EMBED_PARAM}`;
export const METADATA_VIEWS_HELP = `${HELP_ADMIN_PATH}metadata_views/${EMBED_PARAM}`;
export const RECYCLE_HELP = `${HELP_ADMIN_PATH}recycle${EMBED_PARAM}`;
export const SETTINGS_HELP = `${HELP_ADMIN_PATH}settings${EMBED_PARAM}`;
export const STATISTICS_HELP = `${HELP_ADMIN_PATH}statistics${EMBED_PARAM}`;
export const STORAGES_HELP = `${HELP_ADMIN_PATH}storage${EMBED_PARAM}`;
export const TRANSCODERS_HELP = `${HELP_ADMIN_PATH}transcoders${EMBED_PARAM}`;
export const ICONIK_TRANSCODER_HELP = `${HELP_ADMIN_PATH}transcoders/iconik#parameters${EMBED_PARAM}`;
export const USERS_HELP = `${HELP_ADMIN_PATH}user${EMBED_PARAM}`;
export const ACL_TEMPLATES_HELP = `${HELP_ROOT}entities/access_control_templates${EMBED_PARAM}`;
export const APP_TOKENS_HELP = `${HELP_ADMIN_PATH}appl_tokens${EMBED_PARAM}`;
export const CUSTOM_ACTIONS_HELP = `${HELP_ADMIN_PATH}custom_actions${EMBED_PARAM}`;
export const WEBHOOKS_HELP = `${HELP_ADMIN_PATH}webhooks${EMBED_PARAM}`;
export const BILLING_HELP = `${HELP_ADMIN_PATH}billing${EMBED_PARAM}`;
export const SAML_HELP = `${HELP_ADMIN_PATH}saml${EMBED_PARAM}`;
export const ACLS_HELP = `${HELP_ROOT}admin/access_control/${EMBED_PARAM}`;
export const ACLS_ENTITY_HELP = `${HELP_ROOT}entities/acls${EMBED_PARAM}`;
export const MANAGE_PROXY = `${HELP_ROOT}asset/files/proxy${EMBED_PARAM}`;
export const MANAGE_MEDIA_FORMATS = `${HELP_ROOT}asset/files/media_formats${EMBED_PARAM}`;
export const MANAGE_OTHER_FORMATS = `${HELP_ROOT}asset/files/other_formats${EMBED_PARAM}`;
export const MANAGE_SUBTITLES = `${HELP_ROOT}asset/files/subtitles${EMBED_PARAM}`;
export const SEARCH_FILTERS = `${HELP_ROOT}search/filters${EMBED_PARAM}`;
export const COLLECTIONS = `${HELP_ROOT}collections/index${EMBED_PARAM}`;
export const SAVED_SEARCHES = `${HELP_ROOT}search/savedsearch${EMBED_PARAM}`;
export const METADATA = `${HELP_ROOT}metadata/index${EMBED_PARAM}`;
export const SEARCH_HISTORY = `${HELP_ROOT}search/search_history${EMBED_PARAM}`;
export const COMMENTS = `${HELP_ROOT}asset/comments/index${EMBED_PARAM}`;
export const REVIEW_AND_APPROVE = `${HELP_ROOT}review/index${EMBED_PARAM}`;
export const FILES = `${HELP_ROOT}entities/files${EMBED_PARAM}`;
export const POSTERS = `${HELP_ROOT}asset/posters/index${EMBED_PARAM}`;
export const SHARES = `${HELP_ROOT}sharing/index${EMBED_PARAM}`;
export const HISTORY = `${HELP_ROOT}asset/history${EMBED_PARAM}`;
export const RELATIONS = `${HELP_ROOT}asset/relations${EMBED_PARAM}`;
export const TIME_BASED_METADATA = `${HELP_ROOT}asset/time_based_metadata${EMBED_PARAM}`;
export const SUBCLIPS = `${HELP_ROOT}asset/subclips/index${EMBED_PARAM}`;
export const TRANSCRIPTIONS = `${HELP_ROOT}asset/transcription/index${EMBED_PARAM}`;

export const AGENT_HELP = `${HELP_ROOT}agent/`;
